
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 640 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"m192 416h64v-32h-64zm384-192h-32v-32a96 96 0 0 0 -96-96h-112v-80a16 16 0 0 0 -32 0v80h-112a96 96 0 0 0 -96 96v32h-32a32 32 0 0 0 -32 32v128a32 32 0 0 0 32 32h32a96 96 0 0 0 96 96h256a96 96 0 0 0 96-96h32a32 32 0 0 0 32-32v-128a32 32 0 0 0 -32-32zm-480 160h-32v-128h32zm416 32a64.2 64.2 0 0 1 -64 64h-256a64.2 64.2 0 0 1 -64-64v-224a64 64 0 0 1 64-64h256a64 64 0 0 1 64 64zm64-32h-32v-128h32zm-160-192a64 64 0 1 0 64 64 64.1 64.1 0 0 0 -64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1 -32 32zm-32 128h64v-32h-64zm-96 0h64v-32h-64zm-64-224a64 64 0 1 0 64 64 64.1 64.1 0 0 0 -64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1 -32 32z"}})])
          )
        }
      }
    